import axios from "axios";
import { environment } from "../../environments/environment.ts";
import { useUserStore } from "@/store/user.ts";

export const strapiUrl = `${environment.BACKEND_URL}:${environment.BACKEND_PORT}`;
export const strapiApiUrl = `${strapiUrl}/api`;

export const createNewAxios = () => {
    return axios.create({
        baseURL: strapiApiUrl,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        timeout: 0,
    });
};

const apiClient = createNewAxios();
export default apiClient;

// TODO: check if necessary..

// apiClient.interceptors.response.use(
//     function (response: any ) {
//         return response;
//     },

//     function (error: any) {
//         console.error("#error response", error.response, error);

//         if (!error.response) {
//             error.status = 'Network Error';
//         }

//         throw error;
//     }
// );


apiClient.interceptors.request.use(async (config) => {

    const userStore = useUserStore();
    const token = await userStore.loadJwt();

    if (token && token !== "undefined") {   // Token is sometimes returned as "undefined" which leads to errors
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});